
export default {
  name: 'DropdownGroup',

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleItemClick(item) {
      const event = new CustomEvent('dropdown:item-click', {
        detail: { item },
      })
      window.dispatchEvent(event)
    },
  },
}
